import React from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import classNames from 'classnames';
import ChangesetThumbnail from '../../../../../../../../ChangesetThumbnail';

const ChangesetDetailsPushPinChange = ({ isLoadingThumbnails, thumbnailUrl, documentName, description, isDeletePushpin }) => {
  const documentNameToRender = documentName || T.translate('changeset.documentUnavailable');
  const documentNameClassName = classNames({
    'ChangesetDetailsPushPinChange__document-unavailable': !documentName && !isLoadingThumbnails,
  });

  return (
    <div className="ChangesetDetailsPushPinChange">
      <div className="ChangesetDetailsPushPinChange__thumbnail">
        <ChangesetThumbnail
          isLoading={isLoadingThumbnails}
          thumbnailUrl={thumbnailUrl}
          hasDeletedOverlay={isDeletePushpin}
        />
      </div>
      <div className="ChangesetDetailsPushPinChange__info">
        <div className={documentNameClassName}>{!isLoadingThumbnails && documentNameToRender}</div>
        <div>{description}</div>
      </div>
    </div>
  );
};

ChangesetDetailsPushPinChange.displayName = 'ChangesetDetailsPushPinChange';

ChangesetDetailsPushPinChange.propTypes = {
  isLoadingThumbnails: PropTypes.bool,
  thumbnailUrl: PropTypes.string,
  documentName: PropTypes.string,
  description: PropTypes.object.isRequired,
  isDeletePushpin: PropTypes.bool,
};

export default ChangesetDetailsPushPinChange;
